"use client";

import { useState } from "react";
import { invitationFeatures } from "@/constants/homeData";

export default function InvitationFeatures() {
    const [activeFeature, setActiveFeature] = useState(null);

    return (
        <div className="rounded-2xl border border-primary-light bg-white p-5 shadow-sm">
            <div className="flex items-center justify-between mb-3.5">
                <p className="text-[10px] font-bold uppercase tracking-[0.25em] text-primary">Fitur Tersedia</p>
                <span className="rounded-full bg-primary/10 px-2 py-0.5 text-[10px] font-semibold text-primary">{invitationFeatures.length} fitur</span>
            </div>
            <div className="flex flex-wrap gap-1.5">
                {invitationFeatures.map((feature) => (
                    (() => {
                        const isActive = activeFeature === feature.label;
                        return (
                    <div
                        key={feature.label}
                        role="button"
                        tabIndex={0}
                        onClick={() => setActiveFeature(isActive ? null : feature.label)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                setActiveFeature(isActive ? null : feature.label);
                            }
                        }}
                        className={`group relative flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-medium transition-all cursor-pointer select-none ${
                            feature.badge
                                ? "border-primary/25 bg-primary/8 text-primary-dark"
                                : isActive
                                    ? "border-primary/40 bg-primary/10 text-primary-dark"
                                    : "border-zinc-200 bg-zinc-50 text-zinc-600 hover:border-primary/30 hover:bg-primary/5 hover:text-primary-dark"
                        }`}
                        aria-pressed={isActive}
                    >
                        <span className={`h-1.5 w-1.5 shrink-0 rounded-full ${feature.badge ? "bg-primary" : "bg-zinc-300 group-hover:bg-primary/60"} transition-colors`} />
                        {feature.label}
                        {feature.badge && (
                            <span className="rounded-full bg-primary px-1.5 py-0.5 text-[9px] font-bold leading-none text-white">
                                {feature.badge}
                            </span>
                        )}
                        {/* Hover tooltip */}
                        <div className={`pointer-events-none invisible absolute bottom-full left-1/2 z-30 mb-2 w-52 -translate-x-1/2 rounded-xl border border-primary-light bg-white px-3 py-2.5 text-xs text-zinc-600 leading-relaxed opacity-0 shadow-xl transition-all duration-200 group-hover:visible group-hover:opacity-100 ${
                            isActive ? "visible opacity-100" : ""
                        }`}>
                            <span className="font-semibold text-zinc-800 block mb-0.5">{feature.label}</span>
                            {feature.description}
                            <div className="absolute -bottom-1.5 left-1/2 -translate-x-1/2 h-3 w-3 rotate-45 border-b border-r border-primary-light bg-white" />
                        </div>
                    </div>
                        );
                    })()
                ))}
            </div>
        </div>
    );
}
